enum ChemiNovaEntityType {
  SITE = "site",
  PILOT = "pilot",
  CHELEMENT = "ch_element",
  E3DMODEL = "e3d_model",
  _3DINSTANCE = "e3d_instance",
  ANNEX_DATA = "annex_data",
  TEXTURE_LAYER = "texture_layer",
  ANNOTATION = "annotation",
  CONDITION_REPORT = "condition_report",
  ALTERATION_EVENT = "alteration_event",
  // for Portal display only
  SEARCH = "search",
  COLLECTION = "collection",
  MY_LIST = "list",
}

export default ChemiNovaEntityType;
